<template>
  <section class="page-container">
    <el-col :span="24" class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-select v-model="filters.auditStatus" placeholder="审核状态">
            <el-option :value="0" label="待审核" />
            <el-option :value="1" label="审核通过" />
            <el-option :value="2" label="审核失败" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="list">查询</el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="success" @click="audit(true)">审核通过</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" @click="audit(false)">审核不通过</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <el-table
      v-loading="listLoading"
      :data="results"
      highlight-current-row
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="id" label="编号"></el-table-column>

      <el-table-column prop="entityType" label="举报类型"></el-table-column>

      <el-table-column prop="entityId" label="举报数据ID"></el-table-column>

      <el-table-column prop="category" label="分类"></el-table-column>

      <el-table-column prop="content" label="内容"></el-table-column>

      <el-table-column prop="userId" label="举报用户ID"></el-table-column>

      <el-table-column prop="auditStatus" label="审核状态">
        <template slot-scope="props">
          <span v-if="props.row.auditStatus === 0">待审核</span>
          <span v-if="props.row.auditStatus === 1">通过</span>
          <span v-if="props.row.auditStatus === 2">拒绝</span>
        </template>
      </el-table-column>

      <el-table-column prop="auditTime" label="审核时间">
        <template slot-scope="props">
          <span v-if="props.row.auditTime > 0">{{ props.row.auditTime | formatDate }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="createTime" label="创建时间">
        <template slot-scope="props">{{ props.row.createTime | formatDate }}</template>
      </el-table-column>

      <!--
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button size="small" @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
      -->
    </el-table>

    <!-- 分页 -->
    <my-pagination
      ref="pagebar"
      :page="page"
      @current-change="handlePageChange"
      @size-change="handleLimitChange"
    />
  </section>
</template>

<script>
import MyPagination from "@/components/MyPagination";
export default {
  components: { MyPagination },
  data() {
    return {
      results: [],
      listLoading: false,
      page: {},
      filters: {
        auditStatus: 0,
      },
      selectedRows: [],

      addForm: {},
      addFormVisible: false,
      addLoading: false,

      editForm: {},
      editFormVisible: false,
      editLoading: false,
    };
  },
  mounted() {
    this.list();
  },
  methods: {
    async list() {
      const params = Object.assign(this.filters, {
        page: this.page.page,
        limit: this.page.limit,
      });
      try {
        const data = await this.axios.form("base:/api/admin/report/list", params);
        this.results = data.results;
        this.page = data.page;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.listLoading = false;
      }
    },
    async handlePageChange(val) {
      this.page.page = val;
      await this.list();
    },
    async handleLimitChange(val) {
      this.page.limit = val;
      await this.list();
    },
    handleAdd() {
      this.addForm = {
        name: "",
        description: "",
      };
      this.addFormVisible = true;
    },
    async addSubmit() {
      try {
        await this.axios.form("base:/api/admin/report/create", this.addForm);
        this.$message({ message: "提交成功", type: "success" });
        this.addFormVisible = false;
        await this.list();
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async handleEdit(index, row) {
      try {
        const data = await this.axios.get("base:/api/admin/report/" + row.id);
        this.editForm = Object.assign({}, data);
        this.editFormVisible = true;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async editSubmit() {
      try {
        await this.axios.form("base:/api/admin/report/update", this.editForm);
        await this.list();
        this.editFormVisible = false;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },

    audit(pass) {
      if (!this.selectedRows || !this.selectedRows.length) {
        this.$notify.error({ title: "错误", message: "请选择要审核的内容" });
        return;
      }
      const idList = [];
      for (let i = 0; i < this.selectedRows.length; i++) {
        idList.push(this.selectedRows[i].id);
      }

      const msg = pass
        ? "确定被举报的内容无问题吗？"
        : "确定举报内容有问题吗？操作之后将删除有问题的内容!!!";

      const me = this;
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .form("base:/api/admin/report/audit", {
              pass,
              idList: idList.join(","),
            })
            .then(() => {
              me.$message({
                type: "success",
                message: "操作成功!",
              });
              me.list();
            })
            .catch((rsp) => {
              me.$elnotify.error({ title: "error ", message: rsp.message });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
